import { Label, Stack, TextField } from '@fluentui/react';
import { Address } from '../../../api/address.types';
import { AddressInput, SuggestAddress } from '../../core/AddressInput';
import { useState, useEffect } from 'react';
import { getFullAddressString } from '../../../util/Address';

interface Props {
  address: Address;
  onChange: (address: Address) => void;
}

export const AddressEditor = ({ address, onChange }: Props) => {
  const [suggest, setSuggest] = useState<SuggestAddress>();
  const [instructions, setInstructions] = useState(address.instructions || '');
  const [unit, setUnit] = useState(address.unit || '');
  const [zipcode, setZipcode] = useState(address.zipcode || '');
  const [requireZipcode, setRequireZipcode] = useState(false);
  const [city, setCity] = useState(address.city || '');
  const [requireCity, setRequireCity] = useState(false);

  useEffect(() => {
    if (suggest && !suggest.zipcode) {
      setRequireZipcode(true);
      setZipcode('');
    } else {
      setRequireZipcode(false);
    }
    if (suggest && !suggest.city) {
      setRequireCity(true);
      setCity('');
    } else {
      setRequireCity(false);
    }
  }, [suggest]);

  useEffect(() => {
    onChange({
      ...address,
      ...suggest,
      address: undefined, // Set address to undefined in accordance with deprecation (see annotation).
      city: suggest?.city || city,
      zipcode: suggest?.zipcode || zipcode,
      instructions,
      unit,
    });
    // Intentional to not have address, onChange in dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggest, city, zipcode, instructions, unit]);

  return (
    <Stack tokens={{ childrenGap: 12 }}>
      <div>
        <Label required={true}>Address</Label>
        <AddressInput initialValue={getFullAddressString(address)} onSelect={setSuggest} />
      </div>

      {requireCity && <TextField label="City" value={city} required={true} onChange={(ev, value) => setCity(value!)} data-tid="inp_city" />}
      {requireZipcode && <TextField label="ZIP Code" value={zipcode} required={true} onChange={(ev, value) => setZipcode(value!)} data-tid="inp_zipCode" />}
      <TextField label="Unit/Suite" value={unit} onChange={(ev, value) => setUnit(value!)} data-tid="inp_unitSuite" />
      <TextField label="Entry Instructions" value={instructions} onChange={(ev, value) => setInstructions(value!)} multiline={true} rows={4} data-tid="inp_entryInstructions" />
    </Stack>
  );
};
